// ─── Nachkalkulation: Plan aus dem Auftrag, Ist aus Zeiten und Belegen ──────

import { d, summe } from './dezimal.js';
import { KOSTENARTEN } from './position.js';

/**
 * @param plan       [{ menge, ek_je_einheit: {LOHN,...}, zeitbedarf_min }] — Positionen des angenommenen Auftrags
 * @param ist        { zeiten: [{ minuten, lks_h }], geraete: [{ minuten, kostensatz_h }],
 *                     kosten: [{ kostenart, netto }] }
 * @param vkNetto    Auftragssumme netto
 * @param schwellen  { gelb: 5, rot: 15 } — Überschreitung in % ab der die Ampel umspringt
 */
export function nachkalkulation(plan, ist, vkNetto, schwellen = { gelb: 5, rot: 15 }) {
  const planEk = Object.fromEntries(KOSTENARTEN.map((k) => [k, d(0)]));
  let planMinuten = d(0);
  for (const p of plan || []) {
    const menge = d(p.menge ?? 1);
    for (const k of KOSTENARTEN) planEk[k] = planEk[k].plus(d(p.ek_je_einheit?.[k] ?? 0).mal(menge));
    planMinuten = planMinuten.plus(d(p.zeitbedarf_min ?? 0).mal(menge));
  }

  const istEk = Object.fromEntries(KOSTENARTEN.map((k) => [k, d(0)]));
  let istMinuten = d(0);
  for (const z of ist?.zeiten || []) {
    istEk.LOHN = istEk.LOHN.plus(d(z.minuten).mal(d(z.lks_h)).durch(60));
    istMinuten = istMinuten.plus(d(z.minuten));
  }
  for (const g of ist?.geraete || []) {
    istEk.GERAET = istEk.GERAET.plus(d(g.minuten).mal(d(g.kostensatz_h)).durch(60));
  }
  for (const k of ist?.kosten || []) {
    const ka = KOSTENARTEN.includes(k.kostenart) ? k.kostenart : 'SONSTIGES';
    istEk[ka] = istEk[ka].plus(d(k.netto));
  }

  const zeile = (planW, istW) => {
    const delta = istW.minus(planW);
    const prozent = planW.istNull() ? null : delta.durch(planW).mal(100);
    return { plan: planW.runde(2), ist: istW.runde(2), delta: delta.runde(2), prozent: prozent ? prozent.runde(2) : null };
  };

  const jeKostenart = Object.fromEntries(KOSTENARTEN.map((k) => [k, zeile(planEk[k], istEk[k])]));
  const gesamt = zeile(summe(Object.values(planEk)), summe(Object.values(istEk)));
  const deckungsbeitrag = d(vkNetto ?? 0).minus(summe(Object.values(istEk))).runde(2);

  const ueber = gesamt.prozent ? gesamt.prozent.alsZahl(2) : 0;
  const ampel = ueber >= schwellen.rot ? 'rot' : ueber >= schwellen.gelb ? 'gelb' : 'gruen';

  return {
    je_kostenart: jeKostenart,
    gesamt,
    stunden: { plan_min: planMinuten, ist_min: istMinuten, delta_min: istMinuten.minus(planMinuten) },
    deckungsbeitrag,
    ampel,
  };
}
